module.exports = __webpack_public_path__ + "img/오사카10.35421d3c.jpg";